import {halClient} from "../hal";
import {BBModel} from "../bb_model";
import {context} from "../constants/context";

import sessionStorage from '../utils/storage/session_storage';
import localStorage from '../utils/storage/local_storage';

import {bbAuthorisation} from "../admin/bb_authorisation";


const login = {
    companyLogin(company, params, form) {
        return new Promise((resolve, reject) => {
            company.$post('login', params, form).then((login) => {
                    return login.$get('member').then((member) => {
                            this.setLogin(member);
                            return resolve(member);
                        }
                        , (err) => {
                            return reject(err);
                        }
                    );
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },


    login(form, options) {
        return new Promise((resolve, reject) => {
            if (!options['root']) {
                options['root'] = '';
            }
            const url = options['root'] + `/api/${context.apiVersion}/login`;
            halClient.$post(url, options, form).then((login) => {
                    return login.$get('member').then((member) => {
                            this.setLogin(member);
                            return resolve(member);
                        }
                    );
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },


    FBLogin(company, prms) {
        return new Promise((resolve, reject) => {
            company.$post('facebook_login', {}, prms).then((login) => {
                    return login.$get('member').then((member) => {
                            member = new BBModel.Member.Member(member);
                            sessionStorage.setItem('fb_user', true);
                            this.setLogin(member);
                            return resolve(member);
                        }
                        , (err) => {
                            return reject(err);
                        }
                    );
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },


    companyQuery: (id) => {
        if (id) {
            const comp_promise = halClient.$get(location.protocol + '//' + location.host + `/api/${context.apiVersion}/company/` + id);
            return comp_promise.then((company) => {
                    return company = new BBModel.Company(company);
                }
            );
        }
    },


    memberQuery: (params) => {
        if (params.member_id && params.company_id) {
            const member_promise = halClient.$get(location.protocol + '//' + location.host + `/api/${context.apiVersion}/${params.company_id}/` + 'members/' + params.member_id);
            return member_promise.then((member) => {
                    return member = new BBModel.Member.Member(member);
                }
            );
        }
    },


    ssoLogin(options, data) {
        return new Promise((resolve, reject) => {
            if (!options['root']) {
                options['root'] = '';
            }
            const url = options['root'] + `/api/${context.apiVersion}/login/sso/` + options['company_id'];
            halClient.$post(url, {}, data).then((login) => {
                    return login.$get('member').then((member) => {
                            member = new BBModel.Member.Member(member);
                            this.setLogin(member, true);
                            return resolve(member);
                        }
                    );
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },


    // check if we're logged in as a member - but not an admin
    isLoggedIn() {

        this.checkLogin();
        return context.member && !bbAuthorisation.getUser();
    },


    setLogin(member, persist) {
        const auth_token = member.getOption('auth_token');

        member = new BBModel.Member.Member(member);
        sessionStorage.setItem('login', member.$toStore());
        localStorage.setItem('auth_token', auth_token);
        context.member = member;
        if (persist) {
            // save both auth_token and login to re-use them
            localStorage.setItem('auth_token', auth_token);
            localStorage.setItem('login', member.$toStore());
        }


        return member;
    },


    member() {
        this.checkLogin();
        return context.member;
    },


    checkLogin() {


        if (context.member) {
            return true;
        }

        // check if the user is logged in persistently or is logged in for this session only
        let member = localStorage.getItem('login') || sessionStorage.getItem('login');


        if (member) {
            member = halClient.createResource(member);
            context.member = new BBModel.Member.Member(member);
            return true;
        } else {
            return false;
        }
    },


    logout(options) {
        context.member = null;

        return new Promise((resolve, reject) => {

            if (!options) {
                options = {};
            }
            if (!options['root']) {
                options['root'] = '';
            }
            const url = options['root'] + `/api/${context.apiVersion}/logout`;

            sessionStorage.clear();
            localStorage.clear();

            halClient.$del(url, options, {}).then((logout) => {
                    sessionStorage.clear();
                    localStorage.clear();
                    return resolve(true);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },


    FBLogout(options) {
        sessionStorage.removeItem('fb_user');
        return this.logout(options);
    },


    sendPasswordReset(company, params) {
        return new Promise((resolve, reject) => {
            company.$post('email_password_reset', {}, params).then(() => {
                    return resolve(true);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },


    updatePassword(member, params) {
        params.auth_token = member.getOption('auth_token');
        if (member && params['new_password'] && params['confirm_new_password']) {
            return new Promise((resolve, reject) => {
                member.$post('update_password', {}, params).then((login) => {
                        return login.$get('member').then((member) => {
                                this.setLogin(member, params.persist_login);
                                return resolve(member);
                            }
                            , (err) => {
                                return reject(err);
                            }
                        );
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            });
        }
    }

};
export {
    login
}


